export type PromoDiscountType = 'percentage' | 'fixed_amount';

export interface PromoCode {
  id: number;
  /** Владелец; null — глобальный промокод (админ). */
  sellerId?: number | null;
  code: string;
  description?: string | null;
  discountType: PromoDiscountType;
  discountValue: number;
  minimumCartAmount?: number | null;
  isActive: boolean;
  usageLimitTotal?: number | null;
  usageLimitPerUser?: number | null;
  validFrom?: string | null;
  validUntil?: string | null;
  appliesToCategoryId?: number | null;
  appliesToProductIds?: number[] | null;
  excludeProductIds?: number[] | null;
  metadata?: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
  category?: { id: number; name: string; slug: string } | null;
  usagesCount?: number;
}

export interface CreatePromoCodeDto {
  code: string;
  description?: string;
  discountType: PromoDiscountType;
  discountValue: number;
  minimumCartAmount?: number;
  isActive?: boolean;
  usageLimitTotal?: number;
  usageLimitPerUser?: number;
  validFrom?: string;
  validUntil?: string;
  appliesToCategoryId?: number;
  appliesToProductIds?: number[];
  excludeProductIds?: number[];
  metadata?: Record<string, unknown>;
  /** Разослать пуш всем клиентам (текст собирает бэкенд). Только при создании. */
  sendPushNotification?: boolean;
}

export type UpdatePromoCodeDto = Omit<
  Partial<CreatePromoCodeDto>,
  | 'description'
  | 'minimumCartAmount'
  | 'usageLimitTotal'
  | 'usageLimitPerUser'
  | 'appliesToCategoryId'
  | 'appliesToProductIds'
  | 'excludeProductIds'
  | 'validFrom'
  | 'validUntil'
> & {
  description?: string | null;
  minimumCartAmount?: number | null;
  usageLimitTotal?: number | null;
  usageLimitPerUser?: number | null;
  /** null — сбросить ограничение по категории */
  appliesToCategoryId?: number | null;
  /** [] или null — сбросить списки товаров */
  appliesToProductIds?: number[] | null;
  excludeProductIds?: number[] | null;
  /** null — сбросить даты действия */
  validFrom?: string | null;
  validUntil?: string | null;
};

export const PROMO_DISCOUNT_TYPE_LABELS: Record<PromoDiscountType, string> = {
  percentage: 'Процент',
  fixed_amount: 'Фиксированная сумма',
  // free_delivery: 'Бесплатная доставка',
};
